import Axios from 'axios';

const getOfferAgents = async (
  listingId: string,
  sentTo: string,
  sortBy: string,
) => {
  const { data } = await Axios.get(`/listing/${listingId}/offer_agents`, {
    params: {
      sortBy,
      searchCriteria: sentTo,
    },
  });
  return data;
};
export default getOfferAgents;
